<template>
  <div>
  <modal
    v-if="geoInput"
    ref="modal"
    id="agGeoInputModal"
    class="modal-container"
    v-model="showModal"
    styles="display:flex; flex-direction:column; padding:15px; height:70%; width:75%;"
    :draggable=true
    :resizable=true
    :shiftX=.5
    :shiftY=0
    width="1114px"
    height="85%"
    name="geoInput"
    drag="drag"
    content-class="modal-content"
    resize="resize"
    :fit-parent="true"
    :resize-directions="['br']"
    :clickToClose="false"
    @keyup.enter.native="saveButton_click"
    >
    <div>
      <h4 v-if="geoInput._id" class="agModal-title">Edit GeoInput</h4>
      <h4 v-else class="agModal-title">New GeoInput</h4>
      <hr/>
    </div>
    <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
    <div class="agInputGroup agInputGroupCentered">
      <label>Source:</label>
      <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
    </div>
    <b-input-group style="padding:14px;" size="md" prepend="Name">
      <b-input type="text" v-model="geoInput.name" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <b-input-group style="padding:14px;" size="md" prepend="Description">
      <b-input type="text" v-model="geoInput.description" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Type:</label>
      <b-form-select
        class="agMediumInput"
        v-model="geoInput.subtype"
        :options="types"
        :disabled="disableUI"
        @change="typeField_change"
      ></b-form-select>
    </div>
    <hr />

    <!-- Components based on type -->

    <ag-geoInput-buffer
      v-if="geoInput.subtype=='buffer'"
      ref="buffer"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-buffer>

    <ag-geoInput-distance
      v-if="geoInput.subtype=='distance'"
      ref="distance"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-distance>

    <ag-geoInput-geocode
      v-if="geoInput.subtype=='geocode'"
      ref="geocode"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-geocode>

    <ag-geoInput-nearestFeature
      v-if="geoInput.subtype=='nearestFeature'"
      ref="nearestFeature"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-nearestFeature>

    <ag-geoInput-gisExtension
      v-if="geoInput.subtype=='gisExtension'"
      ref="gisExtension"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-gisExtension>

     <ag-geoInput-intersect
      v-if="geoInput.subtype=='intersect'"
      ref="intersect"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-intersect>

    <ag-geoInput-project
      v-if="geoInput.subtype=='project'"
      ref="project"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-project>

    <ag-geoInput-reverseGeocode
      v-if="geoInput.subtype=='reverseGeocode'"
      ref="reverseGeocode"
      :disableUI="disableUI"
      :workflow="workflow"
      :geoInput="geoInput">
    </ag-geoInput-reverseGeocode>
    </div>

    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Destination:</label>
      <b-input type="text" :value="destName" autocomplete="false" disabled></b-input>
    </div>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <div>
      <hr/>
      <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        style="margin-left: 82%;"
        variant="danger"
        :disabled="disableUI || isLoading"
        @click="deleteButton_click"
      >Delete</b-button>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="isLoading"
        @click="saveButton_click"
        style="float: right;"
      >Save</b-button>
    </div>

    <!-- delete modal -->
    <div>
    <b-modal
        class="agModal"
        ref="deleteModal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @keyup.enter.native="deleteButton_click"
      >
        <template slot="modal-header">
          <h4 class="agModal-title danger">Delete GeoInput</h4>
        </template>
        Are you sure you want to delete geoinput
        <i>{{ name }}</i
        >?
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button class="agModal-buttonLeft" @click="cancel"
            >Cancel</b-button
          >
          <b-button
            class="agModal-buttonRight"
            variant="danger"
            @click="confirmDeleteButton_click"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </div>
  </modal>
  </div>
</template>






<script>
// components
import Buffer from "nodes/geoInputs/Buffer";
import Distance from "nodes/geoInputs/Distance";
import Geocode from "nodes/geoInputs/Geocode";
import NearestFeature from "nodes/geoInputs/NearestFeature";
import GISExtension from "nodes/geoInputs/GISExtension";
import Intersect from "nodes/geoInputs/Intersect";
import Project from "nodes/geoInputs/Project";
import ReverseGeocode from "nodes/geoInputs/ReverseGeocode";

// modules
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-geoInput-modal",

  components: {
    "ag-geoInput-buffer": Buffer,
    "ag-geoInput-distance": Distance,
    "ag-geoInput-geocode": Geocode,
    "ag-geoInput-nearestFeature": NearestFeature,
    "ag-geoInput-gisExtension": GISExtension,
    "ag-geoInput-intersect": Intersect,
    "ag-geoInput-project": Project,
    "ag-geoInput-reverseGeocode": ReverseGeocode
  },

  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },

  data() {
    return {
      showModal:false,
      geoInput: null,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      types: [
        { value: "buffer", text: "Buffer" },
        { value: "distance", text: "Distance" },
        { value: "geocode", text: "Geocode" },
        { value: "gisExtension", text: "GIS Extension" },
        { value: "intersect", text: "Intersect" },
        { value: "nearestFeature", text: "Nearest Feature" },
        { value: "project", text: "Project"},
        { value: "reverseGeocode", text: "Reverse Geocode" }
      ],
    };
  },

  computed: {

    name() {
      if (this.geoInput.name) {
        return this.geoInput.name;
      }
      return this.geoInput.shortname;
    },

    srcStr() {
      if (!this.geoInput.src || this.geoInput.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.geoInput.src.length; i++) {
        var src = this.geoInput.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.geoInput.dest) return this.geoInput.dest.shortname;
      return "";
    },
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events
    cancelButton_click() {
      this.$modal.hide('geoInput');
    },
    async saveButton_click() {
      this.modalMessage = "";

      // alert subcomponent
      if(this.geoInput.subtype) {
        var subcomponent = this.$refs[this.geoInput.subtype];
        subcomponent.prepareForSave();
      }

      var node = {
        object: this.geoInput,
        type: "geoInput"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "geoInput",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.geoInput,
        type: "geoInput"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    async typeField_change() {
      this.geoInput.config = {};
    },

    // emitted Events

    // other

    show() {
      this.setGeoInput();
      setTimeout(() => {
        this.reset();
        // const container = document.getElementsByClassName(
        //   "vfm__content modal-content"
        // );
        // container[0].style =
        //   "max-height:54%;min-height:54%; max-width: 83%; min-width:67%; margin-top:10%; float:right;";
        // this.$vfm.show("geoInput");
        this.$modal.show('geoInput',{ draggable: true });
      }, 250);
    },
    hide(arg) {
      if (arg !== undefined) {
        this.$modal.hide(arg);
      } else {
        this.$modal.hide('geoInput');
      }
    },
    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      if(!this.geoInput.config) 
        this.geoInput.config = {};

      var self = this;
      setTimeout(() => {
        var subcomponent = self.$refs[self.geoInput.subtype];
        if (subcomponent) 
          subcomponent.reset();
      }, 250);      
    },

    setGeoInput() {
        if(this.node && this.node.type == "geoInput") 
          this.geoInput = this.workflow.geoInputs.find((object) => object._id == this.node.object._id);
        else
          this.geoInput = null;
      },
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/geoInputs/GeoInputModal.vue